import React from 'react'
import AccountOverview from 'src/app/AccountOverview/AccountOverview'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { accountOverviewRouteProps } from 'src/navigation/routeProps'

const AccountOverviewAppRoute: AppRoute = {
  id: AppLocation.AccountOverview,
  routeProps: accountOverviewRouteProps,
  component: <AccountOverview />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default AccountOverviewAppRoute
